import {ethers} from "ethers";

const TxHistory = ({ txs }) => {
  return (
    <div className="history">
      <h2 className="history__label">Transaction history</h2>
      <div className="history__table">
        <div className="history__table-row history__table-heading">
          <span className="history__table-heading-cell">block no.</span>
          <span className="history__table-heading-cell">address</span>
          <span className="history__table-heading-cell">Burned amount</span>
        </div>
        {txs.map((el) => (
          <div className="history__table-row">
            <span className="history__white">#{el.blockNumber}</span>
            <div className="history__addresses">
              <p className="history__address-item">
                <span className="history__address-item-label">From:</span>
                <a target="_blank" href={`${process.env.REACT_APP_EXPLORER_LINK}/${el.from}`} className="history__address-blue">
                  {`${el.from.substring(0, 5)}.....${el.from.substring(el.from.length - 4, el.from.length)}`}
                </a>
              </p>
              <p className="history__address-item">
                <span className="history__address-item-label">To: </span>
                <a target="_blank" href={`${process.env.REACT_APP_EXPLORER_LINK}/${ethers.constants.AddressZero}`} className="history__address-blue">0x0000000000</a>
              </p>
            </div>
            <span className="history__white">{el.value.ether} AMB</span>
          </div>
        ))}
      </div>
    </div>
  )
};

export default TxHistory;
